import { createContext } from 'react';

import { Context } from '../../../types';
import { TravelFileNote } from '../types';
import api, { AddNoteToTravelFile, EditNoteInTravelFile, DeleteNoteFromTravelFile } from '../api';
import { TravelFile } from '../../travelFiles/oldModelTypes';
import { getContextDefaultValues } from '../../providersDataManager';

interface ExtendedContext extends Context<TravelFileNote> {
    addNoteToTravelFile: (body: AddNoteToTravelFile) => Promise<TravelFile>;
    editNoteInTravelFile: (body: EditNoteInTravelFile) => Promise<TravelFile>;
    deleteNoteFromTravelFile: (body: DeleteNoteFromTravelFile) => Promise<TravelFile>;
}

export const TravelFileNotesContext = createContext<ExtendedContext>({
    ...getContextDefaultValues(api),
    addNoteToTravelFile: api.addNoteToTravelFile,
    editNoteInTravelFile: api.editNoteInTravelFile,
    deleteNoteFromTravelFile: api.deleteNoteFromTravelFile
});
